// Visitor tracking for flourma.in
// 1. Flourma's own counter: one anonymous "visit" per browser session, sent to our server (/api/track).
//    Lookups are counted by the server itself. Read it in Admin -> Visitors.
// 2. Google Analytics 4: switched on only when REACT_APP_GA_ID (e.g. G-XXXXXXX) is set at build time.
import { api } from "@/lib/api";

// ---- owner devices: Parth's own visits and lookups are not counted ----
// A device counts as "owner" once the flourma.in admin has been opened on it (login), or after visiting
// flourma.in/?me=1 once (for a phone where you never log in). flourma.in/?me=0 undoes it.
const OWNER_KEY = "fl_owner";
export function isOwnerDevice() {
  try {
    const v = localStorage.getItem(OWNER_KEY);
    return v === "1" || (v !== "0" && !!localStorage.getItem("auth_token")); // "0" = counted on purpose
  } catch {
    return false;
  }
}
export function setOwnerDevice(on) {
  try {
    localStorage.setItem(OWNER_KEY, on ? "1" : "0");
  } catch {
    /* storage blocked: nothing to remember */
  }
}
// ?me=1 / ?me=0 in the address: remember the choice, then tidy the address bar
(function readMeParam() {
  try {
    const u = new URL(window.location.href);
    const v = u.searchParams.get("me");
    if (v === "1" || v === "0") {
      setOwnerDevice(v === "1");
      u.searchParams.delete("me");
      window.history.replaceState(null, "", u.pathname + u.search + u.hash);
      window.__flOwnerJustSet = v;
    }
  } catch {
    /* old browser: ignore */
  }
})();

const GA_ID = process.env.REACT_APP_GA_ID;
let gaReady = false;

function loadGA() {
  if (gaReady || !GA_ID) return;
  gaReady = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { anonymize_ip: true });
}

export function trackVisit(page) {
  if (isOwnerDevice()) return; // your own visits are not counted
  loadGA();
  try {
    if (sessionStorage.getItem("fl_visit")) return;
    sessionStorage.setItem("fl_visit", "1");
  } catch {
    /* private mode: count anyway */
  }
  api.post("/track", { page }).catch(() => {});
}

// result: found | needs_last_name | unlocked | not_found | wrong_last_name
export function trackLookup(result, products = []) {
  if (isOwnerDevice()) return;
  if (GA_ID && window.gtag) window.gtag("event", "label_lookup", { result, products: products.join(", ").slice(0, 100) });
}
